// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api: 'https://seriella-dev.quality.com.br',
  apiIA: 'https://seriella-ia-dev.quality.com.br',
  apiLocal: 'http://localhost:8080',
  refreshToken: '',
  versionPkg: require('../../package.json').version,

  datadog: {
    applicationId: 'a060bb54-28a6-4fe0-b14d-b86ca840a824',
    clientToken: 'pub0b1cb3bdac6c06f782e4d0ae79b25982',
    site: 'datadoghq.com',
    service: 'seriella-angular',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.